let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jQGZH")).then(() => parcelRequire('3mwl5'));